<template>
  <div class="panel-body" v-if="singleMember.level !== undefined">
    <v-layout row wrap>
      <v-flex lg4 md4 sm12 xs12>
        <v-card flat>
          <v-container>
            <v-img v-if="singleMember.hasOwnProperty('profile_image') === false || singleMember.profile_image === null" width="100%" src="https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.pixabay.com%2Fphoto%2F2016%2F08%2F08%2F09%2F17%2Favatar-1577909_960_720.png&f=1" alt=""></v-img>
            <v-img v-else alt="member profile image" class="img-circle m-b m-t-md" :src="singleMember.profile_image" width="100%"></v-img>
            <br>
            <h4 class="earth-color">{{singleMember.full_name.toUpperCase()}} - {{singleMember.member_id}}</h4>
            <p><b>{{singleMember.level}} ({{singleMember.residence}} - {{singleMember.setting}}) Membership</b></p>
            <p>Email: <b>{{singleMember.email}}</b></p>
            <p>Phone: <b>{{singleMember.tel_number}}</b></p>
            <p>Salesforce AccountID: <b>{{singleMember.salesforce_account_uuid}}</b></p>
            <p>Salesforce ContactID : <b>{{singleMember.salesforce_contact_uuid}}</b></p>
            <p>Salesforce Opportunity ID: <b>{{singleMember.salesforce_membership_uuid}}</b></p>
            <p>DOB: <b>{{formated_date(singleMember.dob)}}</b></p>
            <p>Postal Address: <b>{{singleMember.posatal_address}}</b></p>
            <p>Postal Code: <b>{{singleMember.postal_code}}</b></p>
            <p>Gender: <b>{{singleMember.gender}}</b></p>
            <p>Household: <b>{{singleMember.household_type}}</b></p>
            <p>Expiry: <b>{{formated_date(singleMember.expiry_date)}}</b></p>
            <p>Amount: <b> KES {{$roundOff(singleMember.amount)}}</b></p>
            <p>Mode of Payment: <b> {{singleMember.payment_method}}</b></p>
            <p>Payment Date: <b> {{singleMember.payment_date}}</b></p>
            <p v-if="singleMember.payment_status === false">Payment Status: <v-chip color="red" text-color="white" small><v-avatar><v-icon>cancel</v-icon></v-avatar>Pending Payment</v-chip></p>
            <p v-if="singleMember.payment_status === true">Payment Status: <v-chip color="green" text-color="white" small><v-avatar><v-icon>check_circle</v-icon></v-avatar>Paid</v-chip></p>
          </v-container>
        </v-card>
        <v-card flat>
          <v-container>
            <v-layout row wrap>
              <v-flex lg12 md12 sm12 xs12 class="mb-2">
                <div class="contact-stat">
                  <vue-core-image-upload class="v-btn v-btn--depressed theme--light warning"
                                         :crop="false"
                                         @imageuploaded="imageuploaded"
                                         inputOfFile="file"
                                         :max-file-size="5242880"
                                         :url="url()">
                    Upload/Change Image
                  </vue-core-image-upload>
                </div>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12 class="mb-2">
                <v-btn v-if="singleMember.payment_status === false"
                       color="primary"
                       :depressed="true"
                       block
                       @click="remindPayment()">
                  Send Payment Reminder
                </v-btn>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12 class="mb-2">
                <v-btn v-if="singleMember.payment_status === false"
                       color="warning"
                       :depressed="true"
                       block
                       @click="renewMembership()">
                  <v-icon left>autorenew</v-icon>
                  Renew Membership
                </v-btn>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12>
                <v-btn :loading="$loadingTrue"
                       color="error"
                       :depressed="true"
                       block
                       @click="deleteMember()">
                  Delete Member
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex lg8 md8 sm12 xs12>
        <v-container>
          <v-tabs v-model="active"
                  white
                  slider-color="primary">
            <v-tab key="visits" ripple>Visits</v-tab>
            <v-tab key="beneficiaries" ripple>Beneficiaries <v-badge right><span slot="badge">{{singleMember.family.length}}</span></v-badge></v-tab>
            <v-tab key="updates" ripple>Update</v-tab>
            <v-tab-item key="visits">
              <v-card flat>
                <v-spacer></v-spacer>
                <v-text-field append-icon="search"
                              text="Search"
                              single-line
                              hide-details
                              v-model="search"
                              md6></v-text-field>
                <v-data-table :headers="columns"
                              :items="allMemberVisits"
                              :search="search"
                              :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
                              :disable-initial-sort="true"
                              :loading="$loadingTrue">
                  <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <td class="fancy" style="text-transform: capitalize">
                      <router-link :to="{ name: 'Booking', params: { booking_id: props.item.booking_public_id }}"><a class="text-dark"><u>{{props.item.booking_ref_code}}</u></a></router-link>
                    </td>
                    <td class="fancy">{{ formated_date_time(props.item.created_at)}}</td>
                    <td class="fancy">{{ props.item.booking_type}}</td>
                    <td class="fancy">{{ formated_date(props.item.booking_check_in_date)}}</td>
                    <td class="fancy">{{ formated_date(props.item.booking_check_out_date)}}</td>
                    <td class="fancy">{{ props.item.guest_total}}</td>
                    <td class="fancy" v-bind:style="props.item.booking_color">{{ props.item.booking_status}}</td>
                    <td class="fancy">
                      <v-btn :depressed="true" small color="primary" @click="openBooking(props.item.booking_public_id)">View Booking</v-btn>
                    </td>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                  </v-alert>
                </v-data-table>
                <vue-json-excel type="csv"
                                worksheet="Bookings Data"
                                :name="'Member ' + singleMember.member_id + ' ' + this.$moment().format('DD-MM-YYYY') + ' Report.csv'"
                                :data="allMemberVisits"
                                :fields="reportFields">
                  <v-btn color="warning" :depressed="true">GENERATE REPORT</v-btn>
                </vue-json-excel>
              </v-card>
            </v-tab-item>
            <v-tab-item key="beneficiaries">
              <v-btn v-if="edit === false" @click="addBeneficiary(singleMember)">Add New Beneficiary</v-btn>
              <v-btn v-if="edit === true" color="warning" @click="cancelAddBeneficiary()">Cancel Addition</v-btn>
              <v-card flat v-if="singleMember.family_count === 0">
                <v-container>
                  <p>{{singleMember.full_name}} has no beneficiaries.</p>
                </v-container>
              </v-card>
              <v-card v-else v-for="(beneficiary, key) in singleMember.family" :key="key" style="margin-bottom: 2%" flat>
                <v-container v-if="edit === false">
                  <p>Name: <b>{{beneficiary.first_name}} {{beneficiary.sur_name}}</b></p>
                  <p>Email: <b>{{beneficiary.email}}</b></p>
                  <p>Phone: <b>{{beneficiary.phone_number}}</b></p>
                  <p>Gender: <b>{{beneficiary.gender}}</b></p>
                  <p>Date of Birth: <b>{{formated_date(beneficiary.dob)}}</b></p>
                  <v-btn :depressed="true" color="warning" @click="editBeneficiary(beneficiary)" v-if="editB === false">Edit</v-btn>
                  <v-btn :depressed="true" color="error" @click="deleteBeneficiary(beneficiary.public_id)" v-if="editB === false">Delete ({{delete_count}})</v-btn>
                  <v-btn :depressed="true" color="error" @click="cancelEditBeneficiary()" v-if="editB === true">Cancel Edit</v-btn>
                </v-container>
              </v-card>
              <v-card v-if="edit === true" style="margin-top: 2%">
                <v-container>
                  <h4 class="earth-color">ADD BENEFICIARY</h4>
                  <v-form>
                    <v-layout row wrap>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-select label="Title"
                                    v-model="beneficiary.title"
                                    :items="['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Eng.', 'Prof.']"
                                    :rules="[v => !!v || 'Title method is required']"
                                    required
                                    :loading="$loadingTrue"></v-select>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.first_name"
                                        :rules="requiredRules"
                                        label="First Name"
                                        maxlength="20"
                                        required></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.sur_name"
                                        :rules="requiredRules"
                                        label="Last Name"
                                        maxlength="20"
                                        required></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-select label="Gender"
                                    v-model="beneficiary.gender_id"
                                    :items="allGender"
                                    :rules="[v => !!v || 'Gender is required']"
                                    item-text="name"
                                    item-value="public_id"
                                    required
                                    :loading="$loadingTrue"></v-select>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-dialog ref="dialog"
                                    persistent
                                    v-model="modal1"
                                    lazy
                                    full-width
                                    width="290px"
                                    :return-value.sync="beneficiary.dob">
                            <v-text-field slot="activator"
                                          label="Date of Birth"
                                          v-model="beneficiary.dob"
                                          :rules="requiredRules"
                                          readonly></v-text-field>
                            <v-date-picker v-model="beneficiary.dob"
                                           scrollable>
                              <v-spacer></v-spacer>
                              <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                              <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(beneficiary.dob)">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.id_alien_number"
                                        label="ID Number/Alien ID"
                                        hint="Required for every visit *"
                                        maxlength="30"></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg6 md6 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.email"
                                        label="Email"
                                        required
                                        type="email"></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg6 md6 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.phone_number"
                                        label="Phone Number (e.g. +XXX...)"
                                        minlength="13"
                                        type="number"></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.postal_code"
                                        :rules="requiredRules"
                                        label="Postal Code"
                                        maxlength="20"
                                        required></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.postal_address"
                                        :rules="requiredRules"
                                        label="Postal Address"
                                        maxlength="20"
                                        required></v-text-field>
                        </v-container>
                      </v-flex>
                    </v-layout>
                    <v-btn :depressed="true" block color="primary" @click="postBeneficiary()">Add Beneficiary</v-btn>
                  </v-form>
                </v-container>
              </v-card>
              <v-card v-if="editB === true" style="margin-top: 2%">
                <v-container>
                  <h4 class="earth-color">EDIT BENEFICIARY</h4>
                  <v-form>
                    <v-layout row wrap>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-select label="Title"
                                    v-model="beneficiary.title"
                                    :items="['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Eng.', 'Prof.']"
                                    :rules="[v => !!v || 'Title method is required']"
                                    required
                                    :loading="$loadingTrue"></v-select>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.first_name"
                                        :rules="requiredRules"
                                        label="First Name"
                                        maxlength="20"
                                        required></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.sur_name"
                                        :rules="requiredRules"
                                        label="Last Name"
                                        maxlength="20"
                                        required></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-select label="Gender"
                                    v-model="beneficiary.gender_id"
                                    :items="allGender"
                                    :rules="[v => !!v || 'Gender is required']"
                                    item-text="name"
                                    item-value="public_id"
                                    required
                                    :loading="$loadingTrue"></v-select>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-dialog ref="dialog"
                                    persistent
                                    v-model="modal1"
                                    lazy
                                    full-width
                                    width="290px"
                                    :return-value.sync="beneficiary.dob">
                            <v-text-field slot="activator"
                                          label="Date of Birth"
                                          v-model="beneficiary.dob"
                                          :rules="requiredRules"
                                          readonly></v-text-field>
                            <v-date-picker v-model="beneficiary.dob"
                                           scrollable>
                              <v-spacer></v-spacer>
                              <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                              <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(beneficiary.dob)">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.id_alien_number"
                                        label="ID Number/Alien ID"
                                        hint="Required for every visit *"
                                        maxlength="30"></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg6 md6 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.email"
                                        label="Email"
                                        required
                                        type="email"></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg6 md6 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.phone_number"
                                        label="Phone Number (e.g. +XXX...)"
                                        minlength="13"
                                        type="number"></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.postal_code"
                                        :rules="requiredRules"
                                        label="Postal Code"
                                        maxlength="20"
                                        required></v-text-field>
                        </v-container>
                      </v-flex>
                      <v-flex lg4 md4 sm12 xs12>
                        <v-container>
                          <v-text-field v-model="beneficiary.postal_address"
                                        :rules="requiredRules"
                                        label="Postal Address"
                                        maxlength="20"
                                        required></v-text-field>
                        </v-container>
                      </v-flex>
                    </v-layout>
                    <v-btn :depressed="true" color="primary" block @click="postUpdateBeneficiary()">Update Beneficiary</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-tab-item>
            <v-tab-item key="updates">
              <new-member></new-member>
            </v-tab-item>
          </v-tabs>
        </v-container>
      </v-flex>
    </v-layout>
    {{updateMember}}
  </div>
</template>
<script>
  import NewMember from './NewMember.vue'
  import VueCoreImageUpload from 'vue-core-image-upload'
  import VueJsonExcel from 'vue-json-excel'

  export default {
    components: {
      VueCoreImageUpload,
      NewMember,
      VueJsonExcel
    },
    data() {
      return {
        search: '',
        active: '',
        editB: false,
        modal1: false,
        edit: false,
        delete_count: 3,
        requiredRules: [
          v => !!v || 'This field is required'
        ],
        reportFields: {
          'Created_At': {
            field: 'created_at',
            callback: (date) => {
              return this.report_date_format(date)
            }
          },
          'Check_In_Date': {
            field: 'booking_check_in_date',
            callback: (date) => {
              return this.report_date_format(date)
            }
          },
          'Check_Out_Date': {
            field: 'booking_check_in_date',
            callback: (date) => {
              return this.report_date_format(date)
            }
          },
          'Booking_Ref': 'booking_ref_code',
          'Booking_Type': 'booking_type',
          'Conservancy_Entry_Fees': 'guest_total',
          'Vehicle_Fees': 'vehicle_total',
          'Entry_Pax': {
            field: 'guests',
            callback: (guests) => {
              let guestList = ''
              let i = 0
              while (i < guests.length) {
                if (guests[i]['no_of_guests'] > 0) {
                  guestList = guestList + guests[i]['guest_type'] + ' (V), '
                }
                i++
              }
              return guestList
            }
          },
          'Vehicles': {
            field: 'vehicles',
            callback: (vehicles) => {
              let vehicleList = ''
              let i = 0
              while (i < vehicles.length) {
                if (vehicles[i]['vehicles'] > 0) {
                  vehicleList = vehicleList + vehicles[i]['vehicle_charge_category'] + ' (V), '
                }
                i++
              }
              return vehicleList
            }
          },
          'Activities': {
            field: 'activities',
            callback: (activities) => {
              let activityList = ''
              let i = 0
              while (i < activities.length) {
                activityList = activityList + activities[i]['inventory_name'] + ', '
                i++
              }
              return activityList
            }
          },
          'Accommodation/Camping': {
            field: 'accommodations',
            callback: (accommodations) => {
              let accommodationList = ''
              let i = 0
              while (i < accommodations.length) {
                accommodationList = accommodationList + accommodations[i]['facility_name'] + ', '
                i++
              }
              return accommodationList
            }
          },
          'Currency': 'booking_currency',
          'Booking_Total': 'booking_total',
        },
        member: {
          type: '',
          registration_type: '',
          title: '',
          first_name: '',
          last_name: '',
          email: '',
          telephone_number: '',
          registration_date: '',
          member_id: '',
          postal_address: '',
          identification_number: '',
          gender: '',
          postal_code: '',
          dob: '',
          residence: '',
          household: '',
          children: '',
          expiry_date: '',
          partner: {
            title: '',
            first_name: '',
            last_name: '',
            email: '',
            telephone_number: '',
            dob: ''
          }
        },
        beneficiary: {
          title: '',
          first_name: '',
          sur_name: '',
          gender_id: '',
          dob: '',
          id_alien_number: '',
          email: '',
          postal_address: '',
          postal_code: '',
          phone_number: '',
          public_id: '',
          m_public_id: '',
          member_id: this.$route.params.member_id
        },
        existing_member: false,
        columns: [
          {
            text: 'Ref',
            value: 'booking_ref_code'
          },
          {
            text: 'Created on',
            value: 'created_at'
          },
          {
            text: 'Booking Type',
            value: ''
          },
          {
            text: 'Check In',
            value: ''
          },
          {
            text: 'Check Out',
            value: ''
          },
          {
            text: 'Number of Guests',
            value: 'guest_total'
          },
          {
            text: 'Status',
            value: ''
          },
          {
            text: 'Action',
            value: ''
          }
        ]
      }
    },
    methods: {
      addBeneficiary(data) {
        this.edit = true
        this.beneficiary.m_public_id = data.public_id
      },
      cancelAddBeneficiary() {
        this.edit = false
      },
      postUpdateBeneficiary() {
        this.$store.dispatch('update_member_beneficiary', this.beneficiary)
        this.editB = false
      },
      editBeneficiary(data) {
        this.editB = true
        this.beneficiary.title = data.title
        this.beneficiary.first_name = data.first_name
        this.beneficiary.sur_name = data.sur_name
        this.beneficiary.email = data.email
        this.beneficiary.phone_number = data.phone_number
        this.beneficiary.id_alien_number = data.id_alien_number
        this.beneficiary.gender = data.gender_id
        this.beneficiary.postal_address = data.postal_address
        this.beneficiary.postal_code = data.postal_code
        this.beneficiary.dob = this.$moment(data.dob).format('YYYY-MM-DD')
        this.beneficiary.public_id = data.public_id
      },
      postBeneficiary() {
        this.$store.dispatch('add_member_beneficiary', this.beneficiary)
        this.edit = false
      },
      cancelEditBeneficiary() {
        this.editB = false
      },
      deleteBeneficiary(publicId) {
        if (this.delete_count > 0) {
          this.delete_count = this.delete_count - 1
        } else {
          var data = {
            member_id: this.$route.params.member_id,
            public_id: publicId
          }
          this.$store.dispatch('delete_member_beneficiary', data)
        }
      },
      remindPayment() {
        this.$store.dispatch('remind_membership_payment', this.$route.params.member_id)
      },
      renewMembership() {
        this.$router.push({
          name: 'MembershipPayment',
          params: {
            member_id: this.$route.params.member_id
          }
        })
      },
      openBooking: function (publicId) {
        this.$router.push({
          name: 'Booking',
          params: {
            booking_id: publicId
          }
        })
      },
      imageuploaded: function () {
        this.$store.dispatch('get_member', this.$route.params.member_id)
      },
      url: function () {
        return this.$imageUniversalUrl() + ':5004/v1/profile/upload/' + this.$route.params.member_id
      },
      deleteMember: function () {
        var data = {
          member_id: this.$route.params.member_id,
        }
        this.$store.dispatch('delete_member', data)
      },
    },
    beforeCreate() {
      this.$store.dispatch('get_member', this.$route.params.member_id)
    }
  }
</script>

<style>
  .mb-2 {
    margin-bottom: 8px;
  }
</style>
